import { render, staticRenderFns } from "./MoreBusinessInfo.vue?vue&type=template&id=32006e34&scoped=true&"
import script from "./MoreBusinessInfo.vue?vue&type=script&lang=js&"
export * from "./MoreBusinessInfo.vue?vue&type=script&lang=js&"
import style0 from "./MoreBusinessInfo.vue?vue&type=style&index=0&id=32006e34&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32006e34",
  null
  
)

export default component.exports